const REFERRAL_CODE_KEY = "referral_code";

// Session-scoped: a referral should only attribute the booking made in the
// same browsing session it was picked up in, not resurface weeks later.
export function getReferralCode() {
  if (typeof window === "undefined") return null;
  return sessionStorage.getItem(REFERRAL_CODE_KEY);
}

export function storeReferralCode(code) {
  if (typeof window === "undefined" || !code) return;
  sessionStorage.setItem(REFERRAL_CODE_KEY, code);
}

export function clearReferralCode() {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(REFERRAL_CODE_KEY);
}
